export const Banner = () => {
    return(
        <div id="carouselBanner" className="carousel slide titleSection-banner" data-bs-ride="carousel">
            <div className="carousel-inner">
                <div className="carousel-item active text-center p-4">
                    <p>Spend 130 usd & <strong> Save 20% </strong> code: Royal20</p>
                </div>
            </div>
            <button className="carousel-control-prev" type="button" data-bs-target="#carouselBanner" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#carouselBanner" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
            </button>
        </div>
    )
};
